import { XMarkIcon, Squares2X2Icon } from '@heroicons/react/24/outline';

/**
 * Chip component for displaying a selected template as an attachment.
 *
 * Shows the grid icon, truncated title, and remove button.
 * Similar to the PDF and Book chips in the Unlimited input.
 */
export const TemplateChip = ({ template, onRemove }) => {
  if (!template) return null;

  return (
    <div className='inline-flex items-center gap-2 pl-3 pr-1.5 py-1.5 bg-gray-50 border border-gray-200 rounded-lg max-w-full'>
      {/* Template icon */}
      <Squares2X2Icon className='w-4 h-4 text-gray-500 flex-shrink-0' />

      {/* Title */}
      <span className='text-sm text-gray-700 truncate max-w-[180px]' title={template.title}>
        {template.title || 'Untitled Template'}
      </span>

      {/* Remove button */}
      <button
        onClick={onRemove}
        className='p-1 text-gray-500 hover:text-gray-700 hover:bg-gray-200 rounded transition-colors'
        aria-label='Remove template'>
        <XMarkIcon className='w-4 h-4' />
      </button>
    </div>
  );
};
